import { Button, message, Space, Table, Popconfirm } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../server";
import { userVidRender } from "@extensions/enums";
import CompanyItemUser from "./company-item-user";

const CompanyItemUsers = ({ companyId }) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);

  const getData = () => {
    if (!companyId) return;
    
    setLoading(true);
    serverFetch(`User/ByCompany?companyId=${companyId}`)
      .then((data) => {
        setLoading(false);
        setItems(data);
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  useEffect(() => {
    if (companyId) {
      getData();
    }
  }, [companyId]);

  const handleAdd = () => {
    setSelectedUser({
      companyId: companyId,
    });
  };

  const handleUserModalClose = (refresh) => {
    setSelectedUser(null);
    if (refresh) {
      getData();
    }
  };

  const handleDelete = () => {
    if (selectedRowKeys.length === 0) {
      message.warning("Выберите пользователя для удаления");
      return;
    }

    // Найдем выбранного пользователя по уникальному ключу
    const selectedKey = selectedRowKeys[0]; // Для радиокнопок всегда один элемент
    const selectedUser = items.find(item => `${item.vid}_${item.name}` === selectedKey);
    
    if (!selectedUser) {
      message.error("Пользователь не найден");
      return;
    }

    setLoading(true);
    serverFetch(`User?vid=${encodeURIComponent(selectedUser.vid)}&name=${encodeURIComponent(selectedUser.name)}`, {
      method: "DELETE"
    })
      .then(() => {
        setLoading(false);
        message.success("Пользователь удален");
        setSelectedRowKeys([]);
        getData();
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

    const rowSelection = {
      type: 'radio',
      selectedRowKeys,
      onChange: setSelectedRowKeys,
    };

  const columns = [
    { dataIndex: "vid", title: "Вид", render: userVidRender },
    { dataIndex: "name", title: "Имя" },
    { dataIndex: "pass", title: "Пароль" },
  ];

  return (
    <div>
      <Space style={{ marginBottom: 16 }}>
        <Button type="primary" onClick={handleAdd}>
          Добавить
        </Button>
        
        <Popconfirm
          title="Удалить пользователя"
          description="Удалить выбранного пользователя?"
          onConfirm={handleDelete}
          okText="Да"
          cancelText="Отмена"
        >
          <Button
            type="default"
            danger
            loading={loading}
            disabled={selectedRowKeys.length === 0}
          >
            Удалить
          </Button>
        </Popconfirm>
        
        <Button onClick={getData} loading={loading}>
          Обновить
        </Button>
      </Space>
      
      <Table
        columns={columns}
        dataSource={items}
        loading={loading}
        rowKey={(record) => `${record.vid}_${record.name}`}
        pagination={false}
        size="small"
        rowSelection={rowSelection}
      />
      
      {selectedUser && (
        <CompanyItemUser
          visible={true}
          companyId={selectedUser.companyId}
          onClose={handleUserModalClose}
        />
      )}
    </div>
  );
};

export default CompanyItemUsers;
